module.exports = __webpack_public_path__ + "static/media/travel.ed2cced4.svg";